/**
 * Created by Daniela on 27/09/2016.
 */
import { Component }   from '@angular/core';

@Component({
    template: require('./material.component.html')
})
export class MaterialComponent {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material/material.component.ts
 **/